import { render } from "./Audiovisuel.vue?vue&type=template&id=721c4768"
import script from "./Audiovisuel.vue?vue&type=script&lang=js"
export * from "./Audiovisuel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__